import { useParams } from 'react-router-dom'

import {
  CreatePayrollRunCommentDocument,
  CreatePayrollRunCommentMutation,
  MessagesPageDocument,
  PayrollCyclesDocument,
  PayrollRunCommentsDocument,
} from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'
import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { CommentsCommentValues } from 'modules/comments/components/CommentsContainer/CommentEditor'
import SidepanelComments from 'modules/comments/components/Wrappers/SidepanelComments'
import { usePayrollRunParticipants } from 'modules/compensations/hooks/usePayrollRunParticipants'

const Messages = () => {
  const { id } = useParams()
  const payrollRunId = Number(id)
  const bookkeeperContext = {
    isBookkeeperView: true,
  }

  const { data: payrollCyclesData } = useQuery(PayrollCyclesDocument, {
    variables: {
      ids: [payrollRunId],
    },
    context: bookkeeperContext,
  })

  const companyId =
    payrollCyclesData?.compensations?.payrollRunsConnection?.nodes?.[0]?.cycle?.company?.id ?? 0

  const { data: commentsData } = useQuery(PayrollRunCommentsDocument, {
    variables: {
      id: payrollRunId,
      companyId: companyId,
    },
    context: bookkeeperContext,
  })

  const comments =
    commentsData?.compensations?.payrollRunsConnection?.nodes?.[0]?.commentsConnection?.nodes ?? []

  const participantAccessIds =
    commentsData?.compensations?.payrollRunsConnection?.nodes?.[0]?.payrollRunParticipants ?? []

  const { fetchMentionableAccesses } = usePayrollRunParticipants({
    participantAccessIds,
    isBookkeeperView: true,
  })

  const [addComment] = useMutation(CreatePayrollRunCommentDocument, {
    extractorFn: (result: CreatePayrollRunCommentMutation) =>
      result.compensationsMutations.createCommentCompensationsPayrollRun,
  })

  const handleAddComment = (variables: CommentsCommentValues) => {
    return addComment({
      variables: { ...variables, payrollRunId, companyId },
      context: bookkeeperContext,
      refetchQueries: [PayrollRunCommentsDocument],
      awaitRefetchQueries: true,
    })
  }

  const { loading, data } = useQuery(MessagesPageDocument)

  if (loading) return <Loading />

  if (!data?.compensations?._policies?.compensationActivityManage?.can) {
    return <NotFound />
  }

  return (
    <SidepanelComments
      comments={comments}
      resourceId={payrollRunId}
      onAddComment={handleAddComment}
      onFetchCustomMentionableAccesses={fetchMentionableAccesses}
    />
  )
}

export default Messages
